import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { TherapeuticIndicationApi } from '../../../apis/TherapeuticIndicationApi/TherapeuticIndicationApi';
import { ITherapeuticIndicationAdmin } from '../TherapeuticIndication';

export function useGetTherapeuticIndicationsForAdmin() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.therapeuticIndication, 'admin'],
        queryFn: async (): Promise<ITherapeuticIndicationAdmin[]> => {
            return await TherapeuticIndicationApi.getAllForAdmin();
        },
    });
}
